import { getErrorMessage, isApiSuccess } from "../utils/error-handler";

/**
 * Servicio para obtener estadísticas de usuario
 */
export const statisticsService = {
  /**
   * Obtener estadísticas globales del usuario
   * @param {Object} gameSessionApi - Instancia del API de sesiones de juego
   * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
   */
  getUserStatistics(gameSessionApi) {
    return new Promise((resolve) => {
      gameSessionApi.getUserStatistics((error, data, response) => {
        if (isApiSuccess(error, response, 200)) {
          resolve({ success: true, data });
        } else {
          resolve({
            success: false,
            error: getErrorMessage(error, response, "Error al obtener estadísticas del usuario"),
          });
        }
      });
    });
  },

  /**
   * Obtener estadísticas de una categoría específica
   * @param {Object} gameSessionApi - Instancia del API de sesiones de juego
   * @param {string} sessionType - Tipo de sesión (categoría)
   * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
   */
  getCategoryStatistics(gameSessionApi, sessionType) {
    return new Promise((resolve) => {
      gameSessionApi.getCategoryStatistics(sessionType, (error, data, response) => {
        if (isApiSuccess(error, response, 200)) {
          resolve({ success: true, data });
        } else {
          resolve({
            success: false,
            error: getErrorMessage(error, response, "Error al obtener estadísticas de la categoría"),
          });
        }
      });
    });
  },

  /**
   * Obtener estadísticas de una sesión específica
   * @param {Object} gameSessionApi - Instancia del API de sesiones de juego
   * @param {number} sessionId - ID de la sesión
   * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
   */
  getSessionStatistics(gameSessionApi, sessionId) {
    return new Promise((resolve) => {
      gameSessionApi.getGameSessionStatistics(sessionId, (error, data, response) => {
        if (isApiSuccess(error, response, 200)) {
          resolve({ success: true, data });
        } else {
          resolve({
            success: false,
            error: getErrorMessage(error, response, "Error al obtener estadísticas de la sesión"),
          });
        }
      });
    });
  },

  /**
   * Obtener estadísticas de un usuario específico
   * @param {Object} gameSessionApi - Instancia del API de sesiones de juego
   * @param {number} userId - ID del usuario
   * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
   */
  getUserStatisticsById(gameSessionApi, userId) {
    return new Promise((resolve) => {
      gameSessionApi.getUserStatisticsById(userId, (error, data, response) => {
        if (isApiSuccess(error, response, 200)) {
          resolve({ success: true, data });
        } else {
          resolve({
            success: false,
            error: getErrorMessage(error, response, "Error al obtener estadísticas del usuario"),
          });
        }
      });
    });
  },
};
